import { render } from "./TestEnvironmentBadge.vue?vue&type=template&id=880dee32&scoped=true"
import script from "./TestEnvironmentBadge.vue?vue&type=script&lang=js"
export * from "./TestEnvironmentBadge.vue?vue&type=script&lang=js"

import "./TestEnvironmentBadge.vue?vue&type=style&index=0&id=880dee32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-880dee32"]])

export default __exports__